import propTypes from "prop-types";
import noop from "no-op";
import customTypes from "../customTypes";

export const addonDefaultProps = {
  onIncrement: noop,
  onDecrement: noop
};

export const addonTypes = {
  id: customTypes.stringOrNumber.isRequired,
  amount: propTypes.number,
  name: propTypes.string.isRequired,
  description: propTypes.string,
  price: customTypes.stringOrNumber.isRequired,
  currency: propTypes.string,
  imageUrl: propTypes.string,
  onIncrement: propTypes.func,
  onDecrement: propTypes.func,
  titles: propTypes.PropTypes.object,
  onShowAddonDetailsClick: propTypes.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/types/addonsTypes/addonTypes.js